/**
 * @file API 服務彙整模組
 * @description 整合所有 API 服務，提供統一的 API 存取入口
 */
import template from './template';
import auth from './auth';
import test from './test';
import posts from './posts';
import common from './common';
import category from './category';
import backStage from './backStage';
import postImages from './postImages';
import telegram from './telegram';

/**
 * API 服務物件
 * @description 包含所有 API 模組的統一存取點
 * @property {object} template - 範本相關 API
 * @property {object} auth - 認證相關 API
 * @property {object} test - 測試相關 API
 * @property {object} posts - 文章相關 API (前台)
 * @property {object} category - 分類相關 API
 * @property {object} common - 共用功能 API
 * @property {object} backStage - 後台管理 API
 * @property {object} postImages - 文章圖片 API
 * @property {object} telegram - Telegram 相關 API
 */
export default {
  template,
  auth,
  test,
  posts,
  category,
  common,
  backStage,
  postImages,
  telegram
};
